import { render } from "./EditarCotizacionComponent.vue?vue&type=template&id=24666d68"
import script from "./EditarCotizacionComponent.vue?vue&type=script&lang=js"
export * from "./EditarCotizacionComponent.vue?vue&type=script&lang=js"

import "./EditarCotizacionComponent.vue?vue&type=style&index=0&id=24666d68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__